import ElementBoundingRectPositioning from '@intercom/embercom-composer/components/mixins/element-bounding-rect-positioning';
import $ from 'jquery';
import Em from 'ember';
export default Em.Mixin.create(ElementBoundingRectPositioning, {
  _verticalOffsetForOverflowParent(verticalPosition, $element) {
    let topEdge;
    let bottomEdge;
    let viewport = this._findOverflowParentPosition($element);
    if (!this.get('isMinimized')) {
      $element.css('top', '0');
    }
    topEdge = verticalPosition + $element[0].getBoundingClientRect().top;
    bottomEdge = verticalPosition + $element[0].getBoundingClientRect().bottom;
    if (topEdge < viewport.top) {
      let paddingFromTopOfViewport = 4;
      return this._distanceBetweenTwoPoints(topEdge, viewport.top) + paddingFromTopOfViewport;
    }
    if (bottomEdge > viewport.bottom) {
      return Math.abs(viewport.bottom - bottomEdge) * -1;
    }
    return 0;
  },
  positionPointer(offset) {
    $('#popup-pointer', this.element).remove();
    if (offset) {
      let style = `#${this.get('elementId')} .ic-popup-left:before, #${this.get('elementId')} .ic-popup-left:after, #${this.get('elementId')} .ic-popup-right:before, #${this.get('elementId')} .ic-popup-right:after  { top: calc(50% - ${offset}px); }`;
      // eslint-disable-next-line jquery-unsafe/no-appendTo
      $(`<style id="popup-pointer">${style}</style>`).appendTo($(this.element));
    }
  },
  resetPointer: Em.observer({
    dependentKeys: ['isMinimized'],
    fn() {
      if (this.get('isMinimized')) {
        $('#popup-pointer', this.element).remove();
      }
    },
    sync: true
  }),
  _findOverflowParentPosition($element) {
    let overflowParent;
    if (this.get('viewportSelector')) {
      overflowParent = $(this.get('viewportSelector'));
    } else {
      overflowParent = $element.closest('.embercom-composer').scrollParent();
    }
    if (overflowParent.length && overflowParent[0].documentElement) {
      return {
        top: 0,
        bottom: $(window).height()
      };
    }
    return overflowParent[0].getBoundingClientRect();
  }
});